<div class="lead-places-container ct-manager-master-detail-container">

  <h5> {{ 'LeadAddress' | translate }} </h5>

  <div fxLayout="row wrap">

    <div fxFlex="33.33" fxFlex.md="100" fxFlex.xs="100" fxFlex.sm="100" *ngFor="let configuration of configurations; let idx = index;">

      <app-lead-place [configuration]="configuration" [idx]="idx + 1"></app-lead-place>

    </div>

    <div fxFlex="33.33" fxFlex.md="100" fxFlex.xs="100" fxFlex.sm="100">

      <mat-card class="add-button" (click)="addNewConfiguration()">

        <mat-card-content>

          <button mat-fab>

            <mat-icon>add</mat-icon>

          </button>

        </mat-card-content>

      </mat-card>

    </div>

  </div>

</div>
